import Creative from "./Creative";
import Diy from "./Diy";
import Recipes from "./Recipes";
import Photography from "./Photography";
import Cheesecake from "./recipes/Cheesecake";
import Lasagna from "./recipes/Lasagna";
import DryRub from "./recipes/DryRub";
import BananaBread from "./recipes/Bananabread";
import Fudge from "./recipes/Baileysfudge";
import ChocolateOrange from "./recipes/OrangeChocolateSwirl";
import VinylElephant from "./crafts/VinylElephant";
import SarahsChoiceQuilt from "./crafts/SarahsChoiceQuilt";
import PipeDesk from "./diy/PipeDesk";
import LoftBed from "./diy/LoftBed";
import BuffetRefurbish from "./diy/BuffetRefurbish";
import AntiqueTableRefurbish from "./diy/AntiqueTableRefurbish";
import StairsRefinish from "./diy/StairsRefinish";
import Shortbread from "./recipes/Shortbread";
import PumpkinPie from "./recipes/PumpkinPie";
import SweetPotatoCasserole from "./recipes/SweetPotatoCasserole";
import TaquitoRecipe from "./recipes/Taquitos";
import SnickerdoodleCookie from "./recipes/Snickerdoodle";
import BourbonMolassesCookie from "./recipes/BourbonMolasses";
import CinnamonRolls from "./recipes/CinnamonRolls";
import LocoMocoRecipe from "./recipes/LocoMoco";
import TwiceBakedPotatoesRecipe from "./recipes/TwiceBakedPotatoes";

// Import Crafts last to avoid circular dependency
import Crafts from "./Crafts";

export const CreativeRoutes = [
  { path: "/creative", name: "Creative", component: Creative, exact: true },
  { path: "/creative/crafts", name: "Crafts", component: Crafts },
  { path: "/creative/crafts/vinyl-elephant", name: "Vinyl Elephant", component: VinylElephant },
  { path: "/creative/crafts/sarahs-choice-quilt", name: "Sarah's Choice Quilt", component: SarahsChoiceQuilt },
  { path: "/creative/recipes", name: "Recipes", component: Recipes },
  { path: "/creative/recipes/cheesecake", name: "Cheesecake", component: Cheesecake },
  { path: "/creative/recipes/lasagna", name: "Chicken Lasagna", component: Lasagna },
  { path: "/creative/recipes/dry-rub", name: "Best-Ever Dry Rub", component: DryRub },
  { path: "/creative/recipes/fudge", name: "Bailey's Fudge", component: Fudge },
  { path: "/creative/recipes/shortbread", name: "Shortbread cookies", component: Shortbread },
  { path: "/creative/recipes/pumpkin-pie", name: "Sparkly Pumpkin Pie", component: PumpkinPie },
  { path: "/creative/recipes/sweet-potato-casserole", name: "Sweet Potato Casserole", component: SweetPotatoCasserole },
  { path: "/creative/recipes/buffalo-chicken-taquitos", name: "Buffalo Chicken Taquitos", component: TaquitoRecipe },
  { path: "/creative/recipes/chocolate-orange-swirl", name: "Chocolate Orange Swirl cookies", component: ChocolateOrange },
  { path: "/creative/recipes/french-toast", name: "Banana Bread French Toast", component: BananaBread },
  { path: "/creative/recipes/snickerdoodle", name: "Snickerdoodle Cookies", component: SnickerdoodleCookie },
  { path: "/creative/recipes/bourbon-molasses-cookie", name: "Bourbon Molasses Cookies", component: BourbonMolassesCookie },
  { path: "/creative/recipes/cinnamon-rolls", name: "Cinnamon Rolls", component: CinnamonRolls },
  { path: "/creative/recipes/loco-moco", name: "Loco Moco", component: LocoMocoRecipe },
  { path: "/creative/recipes/twice-baked-potatoes", name: "Twice Baked Potatoes", component: TwiceBakedPotatoesRecipe },
  { path: "/creative/diy", name: "DIY", component: Diy },
  { path: "/creative/diy/pipe-desk", name: "Pipe Desk", component: PipeDesk },
  { path: "/creative/diy/loft-bed", name: "Loft Bed", component: LoftBed },
  { path: "/creative/diy/buffet-refurbish", name: "Buffet Refurbish", component: BuffetRefurbish },
  { path: "/creative/diy/antique-table-refurbish", name: "Antique Table Refurbish", component: AntiqueTableRefurbish },
  { path: "/creative/diy/stairs-refinish", name: "Stairs Refinish", component: StairsRefinish },
  { path: "/creative/photography", name: "Photography", component: Photography },
];